export const _calcDaysRemaining = deadline => {
  let days = Math.floor((deadline - Date.now() / 1000) / 86400)
  if (days.toString().length === 1) days = `0${days}`
  return days
}
